import styled from "styled-components";

export const PricingWrap = styled.div`
  padding: 8px 4px 32px;

  .hero {
    text-align: center;
    max-width: 620px;
    margin: 0 auto 36px;
  }

  .eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #2d53da;
    background: #e3e8fc;
    padding: 5px 14px;
    border-radius: 999px;
    margin-bottom: 14px;
  }

  .heading {
    font-size: 28px;
    font-weight: 700;
    color: #1b1b1b;
    margin-bottom: 8px;
  }

  .subheading {
    font-size: 14.5px;
    color: #636980;
    line-height: 1.5;
  }

  .billing-toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 32px;
    font-size: 13.5px;
    color: #636980;

    .save-tag {
      font-size: 11px;
      font-weight: 600;
      color: #00a651;
      background: #e6f9ee;
      padding: 2px 8px;
      border-radius: 999px;
    }
  }
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    max-width: 420px;
    margin: 0 auto;
  }
`;

export const PlanCard = styled.div`
  position: relative;
  background: #fff;
  border-radius: 16px;
  border: 1px solid ${(props) => (props.$highlight ? "#2D53DA" : "#E5E9F7")};
  box-shadow: ${(props) =>
    props.$highlight
      ? "0 16px 36px rgba(45, 83, 218, 0.18)"
      : "0px 3px 6px #00000012"};
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  transform: ${(props) => (props.$highlight ? "translateY(-8px)" : "none")};

  @media (max-width: 992px) {
    transform: none;
  }

  .badge {
    position: absolute;
    top: -13px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #2d53da 0%, #1f3fb0 100%);
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    padding: 5px 14px;
    border-radius: 999px;
    box-shadow: 0 4px 10px rgba(45, 83, 218, 0.35);
  }

  .plan-name {
    font-size: 15px;
    font-weight: 700;
    color: #2d53da;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 6px;
  }

  .plan-tagline {
    font-size: 13px;
    color: #636980;
    margin-bottom: 18px;
    min-height: 36px;
  }

  .price-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin-bottom: 4px;
  }

  .price {
    font-size: 34px;
    font-weight: 700;
    color: #1b1b1b;
  }

  .price-period {
    font-size: 13.5px;
    color: #636980;
  }

  .price-note {
    font-size: 12px;
    color: #a7a7a7;
    margin-bottom: 20px;
  }

  .cta-btn {
    width: 100%;
    height: 42px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 22px;
  }

  .usage-box {
    background: #f4f6fd;
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 18px;

    .usage-row {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      color: #333a4d;
      padding: 3px 0;

      strong {
        color: #1b1b1b;
      }
    }
  }

  .features-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #a7a7a7;
    margin-bottom: 10px;
  }

  .feature-list {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;

    li {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      font-size: 13.5px;
      color: #333a4d;
      line-height: 1.45;
      margin-bottom: 10px;

      svg {
        color: #00a651;
        font-size: 16px;
        margin-top: 2px;
        flex-shrink: 0;
      }
    }
  }
`;

export const FootNote = styled.div`
  text-align: center;
  font-size: 12.5px;
  color: #a7a7a7;
  margin-top: 28px;
`;
